let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lzYuB")).then(() => parcelRequire('18Lyj'));